/**
 * Создает модальное окно SEO-настроек
 * @returns {HTMLElement} Элемент модального окна
 */
export function createSeoModal() {
    const seoModal = document.createElement('div');
    seoModal.id = 'seo-modal';
    seoModal.className = 'modal-overlay d-none';
    seoModal.innerHTML = `
        <div class="seo-modal-content">
            <div class="modal-header">
                <h2>SEO Settings - <span id="seo-page-title">Home</span></h2>
                <button id="close-seo-modal" class="close-btn">&times;</button>
            </div>
            <div class="modal-body">
                <form id="seo-form">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <h3>Basic SEO</h3>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="meta_title">Meta Title</label>
                            <input type="text" id="meta_title" name="meta_title" class="form-control">
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="canonical_url">Canonical URL</label>
                            <input type="text" id="canonical_url" name="canonical_url" class="form-control">
                        </div>
                        <div class="col-12 mb-3">
                            <label for="meta_description">Meta Description</label>
                            <textarea id="meta_description" name="meta_description" class="form-control" rows="3"></textarea>
                        </div>
                        <div class="col-12 mb-3">
                            <label for="meta_keywords">Meta Keywords</label>
                            <input type="text" id="meta_keywords" name="meta_keywords" class="form-control">
                            <small class="text-muted">Separate keywords with commas</small>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="robots_tag">Robots Tag</label>
                            <input type="text" id="robots_tag" name="robots_tag" class="form-control" value="index, follow">
                        </div>
                        <div class="col-md-6 mb-3">
                            <div class="form-check mt-4">
                                <input class="form-check-input" type="checkbox" id="is_indexed" name="is_indexed" checked>
                                <label class="form-check-label" for="is_indexed">
                                    Allow indexing
                                </label>
                            </div>
                        </div>
                        
                        <div class="col-12 mt-4 mb-4">
                            <h3>Open Graph</h3>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="og_title">OG Title</label>
                            <input type="text" id="og_title" name="og_title" class="form-control">
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="og_type">OG Type</label>
                            <input type="text" id="og_type" name="og_type" class="form-control" value="website">
                        </div>
                        <div class="col-12 mb-3">
                            <label for="og_description">OG Description</label>
                            <textarea id="og_description" name="og_description" class="form-control" rows="3"></textarea>
                        </div>
                        <div class="col-12 mb-3">
                            <label for="og_image">OG Image URL</label>
                            <input type="text" id="og_image" name="og_image" class="form-control">
                        </div>
                        
                        <div class="col-12 mt-4 mb-4">
                            <h3>Twitter Card</h3>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="twitter_card">Twitter Card Type</label>
                            <select id="twitter_card" name="twitter_card" class="form-select">
                                <option value="summary">Summary</option>
                                <option value="summary_large_image">Summary with Large Image</option>
                                <option value="app">App</option>
                                <option value="player">Player</option>
                            </select>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="twitter_title">Twitter Title</label>
                            <input type="text" id="twitter_title" name="twitter_title" class="form-control">
                        </div>
                        <div class="col-12 mb-3">
                            <label for="twitter_description">Twitter Description</label>
                            <textarea id="twitter_description" name="twitter_description" class="form-control" rows="3"></textarea>
                        </div>
                        <div class="col-12 mb-3">
                            <label for="twitter_image">Twitter Image URL</label>
                            <input type="text" id="twitter_image" name="twitter_image" class="form-control">
                        </div>
                        
                        <div class="col-12 mt-4 mb-4">
                            <h3>Schema Markup</h3>
                        </div>
                        <div class="col-12 mb-3">
                            <label for="schema_markup">JSON-LD Schema</label>
                            <textarea id="schema_markup" name="schema_markup" class="form-control" rows="5"></textarea>
                            <small class="text-muted">Enter valid JSON-LD schema markup</small>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button id="save-seo" class="btn btn-primary">Save Changes</button>
                <button id="cancel-seo" class="btn btn-secondary">Cancel</button>
            </div>
        </div>
    `;

    return seoModal;
}

/**
 * Настраивает обработчики событий для SEO-модального окна
 * @param {HTMLElement} modal Элемент модального окна
 * @param {Object} handlers Объект с обработчиками событий
 * @param {Function} handlers.onClose Обработчик закрытия модального окна
 * @param {Function} handlers.onSave Обработчик сохранения данных
 */
export function setupSeoModalHandlers(modal, handlers = {}) {
    const closeSeoModal = modal.querySelector('#close-seo-modal');
    const cancelSeo = modal.querySelector('#cancel-seo');
    const saveSeo = modal.querySelector('#save-seo');

    function closeSeoModalFunc() {
        modal.classList.add('d-none');
        document.body.classList.remove('modal-open');

        if (handlers.onClose && typeof handlers.onClose === 'function') {
            handlers.onClose();
        }
    }

    // Обработчики закрытия модального окна
    if (closeSeoModal) {
        closeSeoModal.addEventListener('click', closeSeoModalFunc);
    }

    if (cancelSeo) {
        cancelSeo.addEventListener('click', closeSeoModalFunc);
    }

    // Обработчик сохранения SEO-данных
    if (saveSeo && handlers.onSave && typeof handlers.onSave === 'function') {
        saveSeo.addEventListener('click', handlers.onSave);
    }
}

/**
 * Открывает модальное окно SEO-настроек
 * @param {string} pageTitle Название страницы
 */
export function openSeoModal(pageTitle = 'Home') {
    const seoModal = document.getElementById('seo-modal');
    if (seoModal) {
        // Устанавливаем название текущей страницы в модальном окне
        const seoPageTitle = seoModal.querySelector('#seo-page-title');
        if (seoPageTitle) {
            seoPageTitle.textContent = pageTitle;
        }

        // Показываем модальное окно
        seoModal.classList.remove('d-none');
        document.body.classList.add('modal-open');
    }
}

/**
 * Закрывает модальное окно SEO-настроек
 */
export function closeSeoModal() {
    const seoModal = document.getElementById('seo-modal');
    if (seoModal) {
        seoModal.classList.add('d-none');
        document.body.classList.remove('modal-open');
    }
}

/**
 * Заполняет форму SEO-данными
 * @param {Object} data Объект с SEO-данными
 */
export function fillSeoForm(data) {
    if (!data) return;

    const form = document.getElementById('seo-form');
    if (!form) return;

    // Обрабатываем каждое поле
    for (const field in data) {
        const element = document.getElementById(field);
        if (element) {
            if (element.type === 'checkbox') {
                element.checked = data[field];
            } else {
                element.value = data[field] || '';
            }
        }
    }
}

/**
 * Получает данные из формы SEO-настроек
 * @returns {Object} Объект с данными формы
 */
export function getSeoFormData() {
    const form = document.getElementById('seo-form');
    if (!form) return {};

    const formData = {};

    // Получаем данные из полей формы
    const elements = form.elements;
    for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        if (element.name) {
            if (element.type === 'checkbox') {
                formData[element.name] = element.checked;
            } else {
                formData[element.name] = element.value;
            }
        }
    }

    return formData;
}